<template>
  <!-- eslint-disable -->
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <div class="home-greeting" style="text-align:center">
        <v-icon x-large>home</v-icon>
        <h1>Hi there, {{getUserName()}}</h1>
        <p>Pick something from the menu to get started.</p>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import { EventBus } from "@/services/eventbus.js";
import authentication from "@/authentication";
export default {
  name: "Home",
  data() {
    return {
      message: "",
      pid: 0,
      showModal: false
    };
  },
  created: /* istanbul ignore next */ function() {
    this.$isInRole([]);
  },
  methods: {
    getUserName() {
      return authentication.getUser().profile.given_name;
    }
  }
};
</script>
